import Watchlist from '@screens/Watchlist';

import IconWatchlist from 'Icon/svg/layout/IconWatchlist';
import NotificationMenu from 'Component/Header/NotificationMenu';
import Inbox from '@screens/Inbox';

const items = [
  {
    id: 'watchlist',
    icon: IconWatchlist,
    element: Watchlist,
    tooltip: 'Watchlist',
  },
  {
    id: 'inbox',
    icon: Inbox,
    element: NotificationMenu,
    tooltip: 'Pesan',
  },
];

export default items;
